import React from 'react';
import { Button, ButtonGroup } from '../../ui-kit';
import styled from 'styled-components';
import { IconThumbsDown, IconThumbsUp } from '../../ui-kit/icons';

import ContractStatisticsProgress from '../../contracts/ContractStatisticsProgress';
import ContractConstraintIndicator from '../../contracts/ContractConstraintIndicator';
import GroupScheduleButton from '../../general/GroupScheduleButton';
import { FormattedDates, formatTimeHuman } from '../../../utils/time';
import round from '../../../utils/round';
import TransactionUserStateLabel from './TransactionUserStateLabel';

const TdWrapperSmall = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  max-width: 150px;
  min-width: 150px;
`;

const TdWrapperBalance = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  max-width: 70px;
  min-width: 70px;
`;

const balance = value => {
  if (!value) return null;
  const roundedValue = round(value, 2);
  if (value > 0) return `+${roundedValue}`;
  return roundedValue;
};

const constraintValue = (contractStatistics, constraintName) => {
  if (!contractStatistics) return null;
  if (!contractStatistics.constraint_evaluation) return null;
  const constraint = contractStatistics.constraint_evaluation.find(evaluation => evaluation.name === constraintName);
  if (!constraint) return null;
  return round(constraint.value, 2);
};

const TableRequestedRow = ({
  interval,
  mayResolve,
  currentUserId,
  selectedConstraint,
  groupId,
  canRespondOnBehalf
}) => {
  const acceptURL = `/groups/${groupId}/schedule/exchanges/duty_exchange_intervals/${interval.id}/accept`;
  const rejectURL = `/groups/${groupId}/schedule/exchanges/duty_exchange_intervals/${interval.id}/reject`;

  const canRespond = canRespondOnBehalf || interval.user_id === currentUserId;
  const contractStatistics = interval.contractStatistics || [];

  return (
    <tr data-interval-id={interval.id} data-user-id={interval.user_id}>
      <td>
        <FormattedDates start={interval.start_time} end={interval.end_time} />
      </td>
      <td>
        <span className="user user-popup" data-user-id={interval.user_id}>
          {interval.user?.nickname}
        </span>
      </td>
      <td>
        {(interval.stations || []).map(station => (
          <GroupScheduleButton
            startTime={interval.start_time}
            endTime={interval.end_time}
            station={station}
            key={station.id}
          />
        ))}
      </td>
      <td>
        {contractStatistics.map(cs => (
          <TdWrapperSmall key={cs.id}>
            <ContractStatisticsProgress contractStatistics={cs} />
          </TdWrapperSmall>
        ))}
      </td>
      <td className="number-column">
        {contractStatistics.map(cs => (
          <TdWrapperBalance key={cs.id}>{balance(cs.balance)}</TdWrapperBalance>
        ))}
      </td>
      <td className="contract-constraints">
        {contractStatistics.map(cs => (
          <TdWrapperBalance key={cs.id}>
            <ContractConstraintIndicator contractStatistics={cs} />
            {'  '}
            {selectedConstraint && constraintValue(cs, selectedConstraint)}
          </TdWrapperBalance>
        ))}
      </td>
      <td>
        <TransactionUserStateLabel transactionState={interval.state} />
      </td>
      <td>{interval.responded_at && formatTimeHuman(interval.responded_at)}</td>
      <td>
        {/* current user can respond to own intervals, or any if has the rights to resolve */}
        {canRespond && interval.state === 'pending' && (
          <ButtonGroup>
            <Button href={acceptURL} title={I18n.t('accept')} variant="success">
              <IconThumbsUp />
            </Button>
            <Button href={rejectURL} title={I18n.t('reject')} variant="danger">
              <IconThumbsDown />
            </Button>
          </ButtonGroup>
        )}
        {mayResolve && (interval.state == 'accepted' || interval.state == 'selected') && (
          <div className="form-check">
            <input
              className="selected_duty_transaction_intervals form-check-input"
              name="selected_duty_transaction_intervals[]"
              value={interval.id}
              type="checkbox"
              title={I18n.t('select')}
            />
          </div>
        )}
      </td>
    </tr>
  );
};

export default TableRequestedRow;
